<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "List" });
import { InputCheckboxToggle } from "../../index.js";
import Icon from "../../../elements/icon/Icon.svelte";
export let keys;
export let blacklist = [];
export let tree = [];
export let query = void 0;
export let options = [];
export let name = "";
export let maxItems;
let visible = [];
const toggleChildren = (item) => {
    if (visible.includes(item.key)) {
        visible = visible.filter((key) => key !== item.key);
    }
    else {
        visible = [...visible, item.key];
    }
};
const isLabelQueryMatch = (label) => query === void 0 ? true : label.toLowerCase().includes(query.toLowerCase());
const isQueryMatch = (branch, query2) => {
    if (query2 === void 0) {
        return true;
    }
    if (isLabelQueryMatch(branch.label)) {
        return true;
    }
    return options.filter(({ key }) => (branch.children ?? []).includes(key)).some((child) => isLabelQueryMatch(child.label));
};
const isIndeterminate = (branch, keys2) => {
    if (keys2.includes(branch.key)) {
        return false;
    }
    if (branch.children === void 0) {
        return false;
    }
    return branch.children.some((child) => keys2.includes(child));
};
const isChecked = (branch, keys2) => (branch.parents ?? []).some((key) => keys2.includes(key));
const isDisabled = (branch, keys2) => {
    if (maxItems !== void 0 && keys2.length >= maxItems && !isChecked(branch, keys2) && !isIndeterminate(branch, keys2)) {
        return true;
    }
    return (branch.parents ?? []).some((key) => blacklist.includes(key));
};
const onAdd = (branch) => {
    keys = [... /* @__PURE__ */new Set([...keys, branch.key])];
    keys = keys.filter((key) => !(branch.children ?? []).includes(key));
    [...branch.parents ?? []].reverse().forEach((key) => {
        const CHILDREN = options.filter(({ parentKey }) => parentKey === key).map(({ key: key2 }) => key2);
        const ARE_ALL_CHILDREN_CHECKED = CHILDREN.every((key2) => blacklist.includes(key2) || keys.includes(key2));
        if (ARE_ALL_CHILDREN_CHECKED) {
            keys = [... /* @__PURE__ */new Set([...keys, key])];
            keys = keys.filter((key2) => !CHILDREN.includes(key2));
        }
    });
};
const onRemove = (branch) => {
    (branch.parents ?? []).forEach((key) => {
        if (!keys.includes(key)) {
            return;
        }
        keys = keys.filter((checkedKey) => checkedKey !== key);
        const CHILDREN = options.filter(({ parentKey }) => parentKey === key).map(({ key: key2 }) => key2).filter((key2) => !blacklist.includes(key2));
        keys = [... /* @__PURE__ */new Set([...keys, ...CHILDREN])];
    });
    keys = keys.filter((key) => !(branch.children ?? []).includes(key));
};
const onChange = (branch, event) => {
    const CHECKBOX = event.target;
    if (CHECKBOX.checked) {
        onAdd(branch);
    }
    else {
        onRemove(branch);
    }
};
</script>

<ul class = 's8-tree'>
    {#each tree as branch}
        {#if isQueryMatch(branch, query)}
            <li>
                <InputCheckboxToggle
                    on:change = { onChange.bind(null, branch) }
                    isChecked = { isChecked(branch, keys) }
                    isIndeterminate = { isIndeterminate(branch, keys) }
                    isDisabled = { isDisabled(branch, keys) }
                    css = 's8-checkbox'
                    { name }
                >
                    { branch.label }
                </InputCheckboxToggle>

                {#if Boolean(branch.items.length)}
                    {#if query === undefined}
                        <Icon
                            key = { visible.some(key => key === branch.key) ? 'chevronUp' : 'chevronDown' }
                            on:click = { toggleChildren.bind(null, branch) }
                            css = 's8-icon'
                        />
                    {/if}

                    {#if visible.some(key => key === branch.key) || query !== undefined}
                        <svelte:self
                            bind:keys
                            tree = { branch.items }
                            { query }
                            { blacklist }
                            { options }
                            { maxItems }
                        />
                    {/if}
                {/if}
            </li>
        {/if}
    {/each}
</ul>

<style>
    ul.s8-tree :global(ul) {
            padding-left: 15px;
        }
        ul.s8-tree :global(label.s8-checkbox) {
            padding: 2px;
            padding-right: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
        }
        ul.s8-tree :global(svg.s8-icon) {
            position: absolute;
            top: 0px;
            right: 5px;
            height: 15px;
            cursor: pointer;
        }
        ul.s8-tree li {
            position: relative;
        }</style>